import { generateAiWheel, getPrimaryWheel, getUserWheels } from '../../services/api';
import { getUserProfilePath, handleFileUpload } from '../../utils/fileUpload';
import { getLoggedInUser } from '../../utils/helpers';
import * as types from '../types';

const userWheelsRequest = () => ({ type: types.USER_WHEELS_REQUEST });
const userWheelsSuccess = (data) => ({
  type: types.USER_WHEELS_SUCCESS,
  payload: data,
});
const userWheelsFailure = (error) => ({
  type: types.USER_WHEELS_FAILURE,
  payload: error,
});

export const getUserWheelsAction = (userId, params) => {
  return async (dispatch) => {
    dispatch(userWheelsRequest());

    try {
      const response = await getUserWheels(userId, params);
      dispatch(userWheelsSuccess(response.data));
    } catch (error) {
      dispatch(userWheelsFailure(error.message));
    }
  };
};

export const getUserPrimaryWheelRequest = () => ({
  type: types.GET_USER_PRIMARY_WHEEL_REQUEST,
});

export const getUserPrimaryWheelSuccess = (data) => ({
  type: types.GET_USER_PRIMARY_WHEEL_SUCCESS,
  payload: data,
});

export const getUserPrimaryWheelFailure = (error) => ({
  type: types.GET_USER_PRIMARY_WHEEL_FAILURE,
  payload: error,
});

export const getUserPrimaryWheelAction = (userId) => {
  return async (dispatch) => {
    dispatch(getUserPrimaryWheelRequest());
    try {
      const response = await getPrimaryWheel();
      dispatch(getUserPrimaryWheelSuccess(response.data));
    } catch (error) {
      dispatch(getUserPrimaryWheelFailure(error.message));
    }
  };
};

const userPublicWheelsRequest = () => ({
  type: types.USER_PUBLIC_WHEELS_REQUEST,
});
const userPublicWheelsSuccess = (data) => ({
  type: types.USER_PUBLIC_WHEELS_SUCCESS,
  payload: data,
});
const userPublicWheelsFailure = (error) => ({
  type: types.USER_PUBLIC_WHEELS_FAILURE,
  payload: error,
});

export const getUserPublicWheelsAction = (userId, params) => {
  return async (dispatch) => {
    dispatch(userPublicWheelsRequest());

    try {
      const response = await getUserWheels(userId, '&is_public=true');
      dispatch(userPublicWheelsSuccess(response.data));
    } catch (error) {
      dispatch(userPublicWheelsFailure(error.message));
    }
  };
};

const userPrivateWheelsRequest = () => ({
  type: types.USER_PRIVATE_WHEELS_REQUEST,
});
const userPrivateWheelsSuccess = (data) => ({
  type: types.USER_PRIVATE_WHEELS_SUCCESS,
  payload: data,
});
const userPrivateWheelsFailure = (error) => ({
  type: types.USER_PRIVATE_WHEELS_FAILURE,
  payload: error,
});

export const getUserPrivateWheelsAction = (userId, params) => {
  return async (dispatch) => {
    dispatch(userPrivateWheelsRequest());

    try {
      const response = await getUserWheels(userId, '&is_public=false');
      dispatch(userPrivateWheelsSuccess(response.data));
    } catch (error) {
      dispatch(userPrivateWheelsFailure(error.message));
    }
  };
};

const userClonedWheelsRequest = () => ({
  type: types.USER_CLONED_WHEELS_REQUEST,
});
const userClonedWheelsSuccess = (data) => ({
  type: types.USER_CLONED_WHEELS_SUCCESS,
  payload: data,
});
const userClonedWheelsFailure = (error) => ({
  type: types.USER_CLONED_WHEELS_FAILURE,
  payload: error,
});

export const getUserClonedWheelsAction = (userId, params) => {
  return async (dispatch) => {
    dispatch(userClonedWheelsRequest());

    try {
      const response = await getUserWheels(userId, '&is_cloned=true');
      dispatch(userClonedWheelsSuccess(response.data));
    } catch (error) {
      dispatch(userClonedWheelsFailure(error.message));
    }
  };
};

export const addUserWheelAction = (data) => ({
  type: types.ADD_USER_WHEEL_SUCCESS,
  payload: data,
});

export const removeUserWheelAction = (data) => ({
  type: types.REMOVE_USER_WHEEL_SUCCESS,
  payload: data,
});

export const editUserWheelAction = (data) => ({
  type: types.EDIT_USER_WHEEL_SUCCESS,
  payload: data,
});

export const makeWheelPrimaryAction = (data) => ({
  type: types.MAKE_WHEEL_PRIMARY,
  payload: data,
});

export const makeWheelPublicAction = (data) => ({
  type: types.MAKE_WHEEL_PUBLIC,
  payload: data,
});

export const makeWheelPrivateAction = (data) => ({
  type: types.MAKE_WHEEL_PRIVATE,
  payload: data,
});

export const resetCategoryColors = () => ({
  type: types.RESET_CATEGORY_COLORS,
});

const userProfileUploadPath = getUserProfilePath({
  user_id: JSON.parse(localStorage.getItem('keyCloak'))?.user?.id,
});

const uploadFiles = async (files) => {
  const locationPromises = files.map((file) => handleFileUpload(file.file, userProfileUploadPath));
  return Promise.all(locationPromises);
};

export const generateAiWheelAction = ({ files = [], data }) => {
  return async (dispatch, getState) => {
    const { prompt, segmentCount, wordCount, variation } = data;
    const temp_id = Math.floor(Date.now() + Math.random());

    try {
      let locations = [];
      const media = [];
      const documents = [];

      // if (files.length > 0) {
      //   const locationResults = await uploadFiles(files);
      //   locations = locationResults.map((result) => result.location);

      //   if (locations.length) {
      //     locations.forEach((file) => {
      //       const mime = file.split('.').pop().toLowerCase();
      //       if (mime === 'png' || mime === 'jpg' || mime === 'jpeg') {
      //         media.push(file);
      //       } else {
      //         documents.push(file);
      //       }
      //     });
      //   }
      // }

      const payload = {
        prompt,
        temperature: variation,
        segment_count: segmentCount,
        word_count: wordCount,
        temp_id,
        media,
        documents,
      };

      const response = await generateAiWheel(payload);
      dispatch(
        addPendingWheel({
          prompt,
          startTime: new Date(),
          temp_id,
          temperature: variation,
          segment_count: segmentCount,
          word_count: wordCount,
        })
      );
    } catch (error) {
      console.error('Error in generateAiWheelAction:', error);
    }
  };
};

export const addPendingWheel = (data) => ({
  type: types.ADD_PENDING_WHEEL,
  payload: data,
});

export const updatePendingWheel = (data) => ({
  type: types.UPDATE_PENDING_WHEEL,
  payload: data,
});

export const removePendingWheel = (data) => ({
  type: types.REMOVE_PENDING_WHEEL,
  payload: data,
});

export const duplicateWheelAction = (id, onSuccess) => {
  return async (dispatch) => {
    try {
      const response = await generateAiWheel(id);
      console.log(response, 'RESSSSS');
      if (response) {
        onSuccess();
      }
    } catch (error) {
      console.log(error, 'RESSSSS E');
    }
  };
};
